<footer>
    <div class="copyright">
        Copyright 2020, Zylops.
    </div>
</footer>

<style>
    footer {
        padding: 40px;
        text-align: center;
    }
    .copyright {
        color: #aaa;
        font-size: 14px;
        display:inline-block;
        padding: 20px;
        border-top: 1px solid #ddd;
    }
</style>